import Accessibility from "./js/Accessibility";
import CustomTriggers from "./js/CustomTriggers";
import ImageFilters from "./js/ImageFilters";
import ImageReplacement from "./js/ImageReplacement";
import Premium from "./js/Premium";
import registerProSwitches from "./switches";

/**
 * Register the premium switch styles first.
 *
 * The free plugin looks styles up in `window.WPDarkModeSwitches` when it builds
 * a switch, so the premium styles have to be in that registry before any switch
 * is rendered.
 */
registerProSwitches();

/**
 * Re-render any switch the free plugin already built.
 *
 * The free bundle runs synchronously at parse time, so by now every switch has
 * been rendered â€” premium styles would have fallen back to the default. Clear
 * the rendered markup and let the free plugin rebuild with the premium styles
 * now present in the registry.
 */
function rerenderSwitches() {
    if (!window.WPDarkModeSwitch) {
        return;
    }

    document.querySelectorAll('.wp-dark-mode-switch-styled').forEach((el) => {
        el.remove();
    });

    window.WPDarkModeSwitch.injectSwitches();
}

rerenderSwitches();

/**
 * Attach premium behaviour as early as possible.
 *
 * The free plugin initialises synchronously at parse time, so by the time this
 * bundle runs its premium methods have already been called as no-op stubs.
 * Premium.init() re-runs the ones that matter after attaching the real
 * implementations.
 */
Premium.init();

document.addEventListener('DOMContentLoaded', () => {
    Accessibility.init()
    CustomTriggers.init();
    ImageFilters.init();
    ImageReplacement.init();

    // Re-apply premium behaviour for anything that depends on the parsed DOM.
    Premium.init();
});
